export default defineNuxtRouteMiddleware((to, from) => {
  const jobsStore = useJobsStore();

  // Clear jobs when navigating to index or manage-jobs pages
  if (to.path === '/' || to.path.startsWith('/manage-jobs')) {
    jobsStore.isPending = true;
    jobsStore.clearFetchedJobs();
  }
});
